export default "__VITE_ASSET__DTsoYttC__";